
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResizeCorner as ObiResizeCornerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resize-corner.js';
 
 
 

 
 export const ObiResizeCorner = createComponent({
   react: React,
   tagName: 'obi-resize-corner',
   elementClass: ObiResizeCornerElement,
   events: {
     
   }
  });
 
 